<ngx-ui-loader loaderId="checkout-loader"></ngx-ui-loader>

<div class="container" [ngStyle]="(displayCharges.length >= 3 || appliedCoupon || passData.paymentType =='membership') ? {'overflow-y': 'scroll'} : {}">
  <div class="row">
 <!-- left Column: Billing Form -->
    <div class="responsive_col_12 col-md-7">
      <app-billing-form  (formDataChange)="onBillingFormChange($event)" [User]="passData"></app-billing-form>

        <div *ngIf="invalidRequiredFields?.length > 0 && !billing_Form_Valid" class="mt-2 pb-5 text-danger cursor-pointer" (click)="highlightFields()">
           <span class="badge badge-red">{{ invalidRequiredFields.length}} </span> field(s) are not complete yet. Click here!
       </div>
    </div>
    <!-- right Column: Payment Summary + Methods -->
    <div class="responsive_col_12 col-md-5">
      <div class="relative w-100 shadow-xl rounded-2xl p-6">
        <div class="payment-summary">
          <div class="d-flex flex-wrap mb-4  pt-3 pb-0 rounded">
            <span class="vertical_line"></span>
            <h1 class="fs-3 text-dark fw-boldest ms-2">
            Your Cart
            </h1>
          </div>


          <div class="summary-row">
            <span class="label fs-5 text-dark fw-boldest"  *ngIf="passData.paymentType !=='membership'">Basic Plan</span>
              <span class="label fs-5 text-dark fw-boldest" *ngIf="passData.paymentType =='membership'">{{this.passData.name}} ({{this.passData.selectedCycle |titlecase}})</span>
            <span class="value text-primary fw-boldest">{{ this.currency}} {{ passData?.selectedPrice }}/-</span>
          </div>

          <div class="summary-row mb-1"  *ngIf="passData.paymentType !=='membership'">
             <p style="margin-top: -13px !important; margin-bottom: 0px !important;">{{this.passData.name}}</p>
          </div>

          <div class="summary-row d-flex align-items-center justify-content-between" *ngIf="passData.paymentType=='membership' && (passData.selectedCycle =='lifetime' ||  passData.canBookMultiple)">
            <span class="label fw-bold " style="font-size: 15px !important;">Quantity</span>
          
            <div class="quantity-control d-flex align-items-center" *ngIf="passData.selectedCycle=='lifetime'">
              {{passData.maxYears}} Year
              </div>
            <div class="quantity-control d-flex align-items-center" *ngIf="passData.selectedCycle!='lifetime' && passData.canBookMultiple">
              <button type="button" class="btn btn-sm" (click)="decrementMonths()"
                [disabled]="passData?.selectedCycle === 'lifetime'">−</button>
          
              <input type="text" [value]="membershipMonths" readonly class="form-control text-center mx-2" style="width: 50px; height: 30px;" />
          
              <button type="button" class="btn btn-sm" (click)="incrementMonths()"
                [disabled]="passData?.selectedCycle === 'lifetime'">+</button>
            </div>
          </div>

          <div *ngFor="let data of displayCharges">
             <div class="separator separator-custom separator-dashed mt-2 mb-4"></div>
            <div class="summary-row">
              <span class="label"> {{ data.name }}
                <ng-container *ngIf="data.type === 'percentage'">
                  ({{ data.value }}%)
                </ng-container>
              </span>
              <span class="value fw-bolder">
                {{ currency == 'INR' ? 'Rs.' : currency }} {{ data.price.toFixed(2) }}/-
              </span>
            </div>
          </div>
          
           <div class="separator separator-custom separator-dashed mt-2 mb-4"></div>

          <!-- <div class="summary-row" *ngIf="appliedCoupon">
            <span class="label">Applied Coupon</span>
            <span class="value text-green">
              {{ appliedCoupon.name }} (-{{ discountAmount }})
              <button class="removecoupon" (click)="removeCoupon()">Remove</button>
            </span>
          </div> -->

          <!-- <div class="coupon-link" *ngIf="!appliedCoupon">
            <a href="javascript:void(0);" (click)="showCouponInput = !showCouponInput">
              {{!showCouponInput? 'Add Coupon':'Remove Coupon'}}
            </a>
          </div> -->

          <div *ngIf="showCouponInput" class="mt-2">
            <app-coupon
              [coupons]="coupons"
              [appliedCoupon]="appliedCoupon"
              [checkOutData]="passData"
              (couponApplied)="onCouponApplied($event)"
               (remove)="removeCoupon()">
            </app-coupon>
          </div>
          <div class="summary-row" *ngIf="appliedCoupon">
            <span class="label"> Discount
              <ng-container *ngIf="appliedCoupon.type=='percentage'">
                ({{ appliedCoupon.value }}%)
              </ng-container>
            </span>
            <span class="value fw-bolder">
            {{discountAmount.toFixed(2)}}/-
            <!-- <span style="text-decoration: line-through;">
              {{ this.currency=='INR'?'Rs.':this.currency }} {{ passData?.selectedPrice }}/-
            </span>
            &nbsp;
            {{ this.currency=='INR'?'Rs.':this.currency }}{{ discounted_originalPrice.toFixed(2) }}/- -->
          </span>

          </div>
          <div class="summary-row " [ngStyle]="{ 'margin-top': appliedCoupon ? '0' : '1rem' }">
            <span class="label">Subtotal</span>
            <span class="value fw-bolder">{{this.currency=='INR'?'Rs.':this.currency}} {{subTotal.toFixed(2)}} /-
               <!-- {{ appliedCoupon ?(discounted_originalPrice.toFixed(2)):passData?.selectedPrice }}/- -->
              </span>
          </div>
          <div *ngIf="passData.taxProfile != null">
            <div  class="summary-row " *ngIf="!passData.taxProfile.isGST || (!isInvoice && passData.taxProfile.isGST)">
            <span class="label">Tax ({{passData.taxProfile.isGST ? "IGST" :"GST"}} {{ passData.taxProfile.taxPercent }}%)</span>
            <span class="value fw-bolder"> {{ this.currency=='INR'?'Rs.':this.currency}} {{ gstAmount.toFixed(2) }}/-</span>
         </div>

           <div class="summary-row " *ngIf="passData.taxProfile.isGST && isInvoice">
            <span class="label">Tax (CGST {{ passData.taxProfile.taxPercent /2}}%)</span>
            <span class="value fw-bolder"> {{ this.currency=='INR'?'Rs.':this.currency}} {{ (gstAmount/2).toFixed(2) }}/-</span>
         </div>
           <div class="summary-row " *ngIf="passData.taxProfile.isGST && isInvoice">
            <span class="label">Tax (SGST {{ passData.taxProfile.taxPercent /2 }}%)</span>
            <span class="value fw-bolder"> {{ this.currency=='INR'?'Rs.':this.currency}} {{ (gstAmount/2).toFixed(2) }}/-</span>
         </div>
          </div>
         <!-- <hr /> -->
          <div class="summary-row total mt-2 fs-md-5 bg-total">
            <span class="label fw-bolder">Total</span>
            <span class="value fw-bolder" >{{ this.currency=='INR'?'Rs.':this.currency}} {{ totalAmount.toFixed(2) }}/-</span>
          </div>
        </div>

        <!-- Payment Method -->
        <form [formGroup]="paymentForm" style="min-height: 150px;"  *ngIf="totalAmount">
          <div class="row fv-row fv-plugins-icon-container my-4">
            <h3 class="text-dark fs-6 mb-3">Choose a payment gateway</h3>

            <ng-container *ngIf="paymentMethods?.length > 0; else loadingSkeleton">
              <div class="row">
                <div *ngFor="let method of paymentMethods" class="col-md-6 mb-4">
                  <label class="btn btn-outline btn-outline-dashed d-flex flex-stack text-start p-3">
                    <div class="d-flex align-items-center me-2">
                      <div class="form-check form-check-custom form-check-solid form-check-primary me-2">
                        <input
                          [value]="method.code"
                          formControlName="paymentMethod"
                          type="radio"
                          class="form-check-input"
                        />
                      </div>
                      <div class="flex-grow-1">
                        <h2 class="d-flex align-items-center fs-7 fw-normal flex-wrap pt-2">
                          {{ method.name }}
                        </h2>
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </ng-container>

            <ng-template #loadingSkeleton>
              <div class="row">
                <div class="col-md-6 mb-4" *ngFor="let skeleton of [1, 2]">
                  <div class="skeleton-loader p-3 rounded bg-light w-100" style="height: 60px;"></div>
                </div>
              </div>
            </ng-template>
          </div>
        </form>

        <!-- Payment Actions -->
        <div class="row fv-row fv-plugins-icon-container mt-0">
          <div class="col-lg-12 mt-4" *ngIf="totalAmount">
            <button [hidden]="selectedMethod === 'paypal'" [disabled]="!billing_Form_Valid"
              class="btn btn-primary w-100 text-white font-medium rounded-lg transition" (click)="handlePayment()">
              Pay Now
            </button>
          </div>


          <div class="col-lg-12 mt-4" *ngIf="!totalAmount">
            <button [disabled]="!billing_Form_Valid" class="btn btn-primary w-100 text-white font-medium rounded-lg transition"
              (click)="createDiscountedTransaction()">
              Proceed
            </button>
          </div>
        
          <div class="col-lg-12 mt-4">
            <ng-container *ngIf="selectedMethod === 'paypal'">
              <ng-container *ngIf="billing_Form_Valid; else invalidMessage">
                <div id="paypal-button-container"></div>
              </ng-container>
              <ng-template #invalidMessage>
                <div class="text-danger mt-2">
                  Please fill all mandatory fields to continue with PayPal payment.
                </div>
              </ng-template>
            </ng-container>
          </div>
        
          <div class="col-lg-12 mt-1">
            <button class="btn w-100 btn-secondary font-medium rounded-lg hover:bg-blue transition"
              (click)="closeDialog()">Cancel</button>
        </div>
        </div>
        
        </div>
    </div>
  </div>
</div>
